<template>
  <div class="map-window__container">
    <div ref="mapElement" class="map-window__leaflet"></div>
    <!-- <v-btn
      fab
      color="white"
      @click="handleClickGpsPositionUpdate"
      class="map-window__gps-position-btn"
      aria-label="Ustal Twoją lokalizację"
    >
      <v-icon color="indigo">mdi-crosshairs-gps</v-icon>
    </v-btn> -->
    <!-- <v-dialog
      v-model="gpsPositionModal"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline primary white--text lighten-2"
          primary-title
        >
          Informacja o Geolokacji
        </v-card-title>

        <v-card-text>
          <h4 class="title mt-5 mb-2">Usługa Geolokacji jest niedostępna</h4>
          <ul class="subtitle-1">
            <li>aby ją uruchomić na przeglądarce Google Chrome:
              należy kliknąć w kłódkę i przełączyć opcję Lokalizacja na "włączony"</li>
            <li>aby ją uruchomić na przeglądarce Mozilla Firefox:
              należy kliknąć w kłódkę i nacisnąć na krzyżyk
              obok opcji "Uzyskiwanie informacji o położeniu"</li>
            <li>aby ją uruchomić na przeglądarce Opera:
              należy kliknąć w kłódkę i przełączyć opcję Lokalizacja na "włączony"</li>
            <li>aby ją uruchomić na przeglądarce Edge:
              Trzeba dodać instukcję</li>
            <li>aby ją uruchomić na przeglądarce Safari:
              Trzeba dodać instukcję</li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="gpsPositionModal = false"
          >
            Zamknij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- <MapOverlay></MapOverlay> -->
    <LayerSelector></LayerSelector>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, ref, onMounted, Ref, computed, watchEffect, watch,
  shallowRef,
  onBeforeUnmount,
} from 'vue';
import { LayerGroup, Map, Marker, TileLayer } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import store from '@/store/index';
import IPosition from '@/interfaces/IPosition';
import { IMapControls } from '@/interfaces/IMapControls';
import { IHandleMapElement } from '@/interfaces/IHandleMapElement';
import { IMapWindowSetup } from '@/interfaces/IMapWindowSetup';
import MapService from '@/services/MapService';
import RedrawService from '@/services/RedrawService';
import LayerSelector from '@/components/map/overlays/LayerSelector.vue';
import MapOverlay from '@/components/map/MapOverlay.vue';
import NotificationService from '@/services/NotificationService';

const useHandleMapElement = (): IHandleMapElement => {
  const mapElement = ref(Object.create(HTMLElement.prototype, {}));
  const mapHandler = ref();
  const currentPosition: Ref<IPosition> = computed(() => {
    const storePosition: IPosition = store.getters.getPosition;
    return {
      lat: storePosition.lat,
      lng: storePosition.lng,
    };
  });
  const currentZoom: Ref<number> = computed(() => {
    const storeZoom: number = store.getters.getZoomFactor;
    return storeZoom;
  });
  const userPositionMarker: Ref<Marker|any> = ref(Marker.prototype);
  const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
  const selectedParkingCode: Ref<string> = computed((): string => store.state.selectedParkingCode);
  const selectedTrafficLineCode: Ref<number | null> = computed((): number | null => store.state.selectedTrafficLineCode);

  onMounted(() => {
    mapHandler.value = new Map(mapElement.value, {
      zoomControl: false,
      // zoomAnimation: false,
    });
    const mapService = new MapService(mapHandler.value);

    mapService.initializeMap();
    mapService.setPostition(currentPosition.value, 14);
    mapService.startPositionSetMode();
    // mapService.setPositionFromGeolocation();

    store.commit('updateLeafletMapInstance', mapHandler.value);

    const redrawService = new RedrawService(mapService);

    Promise.all([
      store.dispatch('setSettingsMap'),
      store.dispatch('setSettingsParams'),
      store.dispatch('updateSegmentsConfig'),
      store.dispatch('updateTranslations'),
      store.dispatch('updateLinks'),
      store.dispatch('updateArticles'),
    ])
    .then(redrawService.initDataAndRedraw)
    .then(() => {
      NotificationService.success('Uruchomienie aplikacji', 'Pomyślnie zainicjalizowano mapę.');
    });

  
    // store.dispatch('updateSettings')
    //   .then(redrawService.initDataAndRedraw)
    //   .then(() => {
    //     NotificationService.success('Uruchomienie aplikacji', 'Pomyślnie zainicjalizowano mapę.');
    //   });

    // handler pulled outside of MapService to avoid
    // cicrular dependencies
    mapHandler.value.on('zoomend', () => {

      // mapHandler.value.eachLayer((layer: any) => {
      //   console.log(typeof layer);
      //   if (layer instanceof LayerGroup) {
      //     mapHandler.value.removeLayer(layer);
      //   }
      // });
      
      mapHandler.value.whenReady(() => {
        redrawService.redrawMap();
      }); 
    });

    watch(() => selectedParkingCode.value, () => {
      redrawService.redrawOnlyParkingGroups();
    });

    // watch(() => selectedTrafficLineCode.value, () => {
    //   redrawService.redrawOnlyTrafficLines();
      
    // });
    watch(() => getContrastActive.value, () => {
      mapService.changeMapContrast();
      redrawService.redrawMap();
    });

    // each minute refresh data on map
    // necessary because rest api
    // does not provide websockets
    setInterval(() => {
      // redrawService.updateDynamicDataAndRedraw();
    }, 60 * 1000);
  });

  return {
    mapElement,
    mapHandler,
    currentPosition,
    currentZoom,
    userPositionMarker,
    getContrastActive,
  };
};

// const useMapControls = (handleMapElement: IHandleMapElement): IMapControls => {
//   const { mapHandler } = handleMapElement;
//   const selectLocationMode = computed(() => store.state.modes.selectLocation);
//   const gpsPositionModal: Ref<boolean> = ref(false);

//   watchEffect(() => {
//     if (selectLocationMode.value === true) {
//       // const mapService = new MapService(mapHandler.value);
//       // mapService.startPositionSetMode();
//     }
//   });

//   const handleClickGpsPositionUpdate = () => {
//     const mapService = new MapService(mapHandler.value);
//     mapService.setPositionFromGeolocation()
//       .catch(() => {
//         gpsPositionModal.value = true;
//       });
//   };

//   return {
//     selectLocationMode,
//     handleClickGpsPositionUpdate,
//     gpsPositionModal,
//   };
// };

const MapWindow: object = defineComponent({
  name: 'MapWindow',
  components: {
    MapOverlay,
    LayerSelector,
  },
  setup() {
    const useHandleMapElementData: IHandleMapElement = useHandleMapElement();

    return {
      ...useHandleMapElementData,
      // ...useMapControls(useHandleMapElementData),
    };
  },
});

export default MapWindow;

</script>

<style scoped lang="scss">
  

  .map-window{
    &__container, &__leaflet{
      height: 100%;
      width: 100%;
    }
    &__leaflet{
      z-index: 1;
    }
    &__container{
      position: relative;
    }
    &__overlay{
      position: absolute;
      top: 0;
      right: 0;
      color: white;
      background: none;
      z-index: 2;
      margin: rem(28px) rem(14px);
    }
    &__gps-position-btn{
      position: absolute;
      z-index: 1;
      left: 0;
      margin-left: 1rem;
      margin-bottom: 1rem;
      top: calc(100% - 200px);
    }
  }
</style>
